import * as React from 'react'

export function ProviderCell({ row }) {
  const savedCourse = row.original

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="text-normal line-clamp-1 font-bold">
        {savedCourse.provider}
      </div>
    </div>
  )
}
